import type { Revision } from '../../types';
import { addUserEdits, type Edits, mergeEdits, mutations } from '../../utils';

/**
 * Mark a page as edited by a user.
 */
export function markPageAsEdited(
    revision: mutations.MutableData<Revision>,
    pageId: string,
    userId: string | string[] | mutations.MutableData<Edits>
) {
    const yEdits = mutations.getIn(revision, ['pages', pageId, 'edits'] as const);
    if (!yEdits) {
        return;
    }

    const result = (() => {
        if (Array.isArray(userId)) {
            return addUserEdits(yEdits, userId);
        }
        if (typeof userId === 'string') {
            return addUserEdits(yEdits, [userId]);
        }
        return mergeEdits(yEdits, userId);
    })();
    mutations.setIn(revision, ['pages', pageId, 'edits'] as const, result);
}
